import { lazy } from 'react'
import { Route } from 'commons/types/route'

const HomePage = lazy(() => import('pages/Home'))

export default [
  {
    path: '/',
    component: HomePage,
  },
] as Route[]
